export default {
  dynamics: '{{change}} vs vorige {{time_unit}}',
};
